import * as Sentry from '@sentry/nextjs'

/**
 * Registra um erro que o código detectou mas não lançou (ex.: status que não
 * existe no mapeamento de uma tela).
 *
 * Substituiu o `window.newrelic.noticeError` em mai/2025, mas até o SC-11130
 * só fazia `console.error`: em produção o aviso morria no navegador. Agora vai
 * para o Sentry. Sem `error`, sobe como mensagem `warning`, agrupada pelo
 * texto: um status novo vira uma issue só, não uma por usuário.
 *
 * O agrupamento pelo texto precisa do `fingerprint` explícito: sem ele o
 * Sentry agrupa pelo call site (esta função), juntando avisos de telas
 * diferentes numa issue só com título `__webpack_exports__.Z`.
 */
export const logError = (message: string, error?: Error): void => {
  if (process.env.NODE_ENV === 'development') {
    console.error(`[Erro] ${message}`, error)
  }

  try {
    if (error) {
      Sentry.captureException(error, { extra: { message } })
    } else {
      Sentry.captureMessage(message, {
        level: 'warning',
        fingerprint: ['logError', message]
      })
    }
  } catch {
    // Telemetria nunca pode quebrar a tela.
  }
}

export default logError
